import React from 'react';
import styled from 'styled-components';
import { Spacing16 } from 'autogen/design-tokens/tokens';
import type { ProductTabIconListModel } from 'autogen/swagger/all';
import { Typography } from 'components/generic/typography';
import IconList from '../../shared/IconList';

const Text = styled(Typography.Body)`
    margin-bottom: ${Spacing16};
`;

const StyledIconList = styled(IconList)`
    margin-bottom: ${Spacing16};
`;

export default function TabIconList({ ...props }: ProductTabIconListModel): JSX.Element {
    const { items, topText, bottomText } = props;

    return (
        <>
            <Text dangerouslySetInnerHTML={{ __html: topText }} />
            {items.length > 0 && <StyledIconList items={items} />}
            {bottomText && <Text dangerouslySetInnerHTML={{ __html: bottomText }} />}
        </>
    );
}
